export enum CmsEnv {
    Qa = 'qa',
    Dev = 'dev',
    Prod = 'prod',
    Local = 'local-dev',
    Test = 'test',
    Mock = 'mock',
}

export enum Sex {
    Male = 'm',
    Female = 'f',
}

export enum VaccineDeliveryMethod {
    Intramuscular = 'внутримышечный',
    Aerosol = 'аэорозольный',
    Oral = 'пероральный',
    Intradermal = 'внутрикожный',
}

export enum InjectionSite {
    Oral = 'через рот',
    Nasally = 'через нос',
    Shoulder = 'плечо',
    hip = 'бедро',
}

export enum LaboratoryOrderSex {
    Male = 'Male',
    Female = 'Female',
}

export enum ScheduleModelSubjectType {
    User = 'user',
    Device = 'device',
    Office = 'office',
}

export enum ScheduleModelStatus {
    Active = 'active',
    Archived = 'archive',
}

export enum SortingOrder {
    Asc = 'ASC',
    Desc = 'DESC',
}

export const asc = SortingOrder.Asc;
export const desc = SortingOrder.Desc;

export enum Channel {
    Sms = 'sms',
    Email = 'email',
    /** топик нотификейшен */
    TgNotificationTopic = 'tgChat',
    /** только топик нотификейшен без пересылания */
    TgNotificationTopicStrict = 'tgNotification',
    /** чат-бот чайки */
    ChaikaTgBot = 'tg',
    /** Для сайта надо, чтоб тегать врачей */
    TelegramName = 'tgName',
    Viber = 'vb',
    FaceBook = 'fb',
    Skype = 'skype',
    WhatsApp = 'wa',
    Zoom = 'zoom',
    ContactEmail = 'contactEmail',
    CityPhone = 'cityPhone',
    /** в пользователя */
    UserTg = 'wp',
    /** в топик пользователя в практике практики */
    UserPracticeTopic = 'wpg',
    /** в топик  практики */
    PracticeTopic = 'pt',
    Default = 'default',
}

export enum OnlineVisitChannel {
    Phone = 'телефон',
    Skype = 'skype',
    Zoom = 'zoom',
}

export enum MessageStatus {
    ReadyForSending = 'ready for sending',
    Dispatched = 'dispatched', // successfully sended to messenger
    Delivered = 'delivered', // delivered to recipient
    Failed = 'failed',
    PossibleSpam = 'possible_spam',
    Error = 'error',
    UndefinedChannel = 'undefined channel',
    DoNotNotify = 'do not notify',
}

export enum MessageExternalStatus {
    Queued = 'queued',
    Processing = 'processing',
    Accepted = 'accepted',
    Delivered = 'delivered',
    Failed = 'failed',
    Unknown = 'unknown',
    Expired = 'expired',
    Cancelled = 'cancelled',
}

export enum LaboratoryServiceOption {
    Medication = 'medication',
    Height = 'height',
    Weight = 'weight',
    Menstruation = 'menstruation',
    Pregnancy = 'pregnancy',
    Diuresis = 'diuresis',
    Localization = 'localization',
    NumberFragments = 'numberFragments',
    CharacterPathologicalProcess = 'characterPathologicalProcess',
    Comment = 'comment',
    CollectionTime = 'collectionTime',
}

export enum ServiceCategory {
    Consultation = 'consultation',
    Laboratory = 'laboratory',
    Dentistry = 'dentistry',
    Archive = 'archive',
    Technical = 'technical',
    Clinic = 'clinic',
    Radiodiagnosis = 'radiodiagnosis',
    UltrasoundDiagnostics = 'ultrasoundDiagnostics',
    CheckUp = 'checkUp',
    Hospital = 'hospital',
    MaterialsAndPreparations = 'materialsAndPreparations',
    OneCProduct = '1CProduct',
    Vaccination = 'vaccination',
}

export enum OrderItemStatus {
    InProgress = 'in progress',
    Failed = 'failed',
    Canceled = 'canceled',
    Done = 'done',
}

export enum LaboratoryTestStatus {
    InProgress = 'in progress',
    Done = 'done',
    Failed = 'failed',
    Canceled = 'canceled',
}

export enum EntryTypeType {
    Consultation = 'Консультация',
    UsDiagnostics = 'УЗ-Диагностика',
    Diagnostics = 'Диагностика',
    Manipulation = 'Манипуляция',
    Tests = 'Анализы',
    System = 'Системная',
}

export enum ReferralStatus {
    Active = 'active',
    Cancelled = 'cancelled',
    Expired = 'expired',
    Executed = 'executed',
}

export enum ReferralSorting {
    BioCodes = 'bio-codes',
    CreationTime = 'creation-time',
    StartDate = 'start-date',
}

export enum OrderStatus {
    Draft = 'draft',
    Canceled = 'canceled',
    Executed = 'executed',
}

export enum FhirOrderDataStatus {
    Completed = 'completed',
    Failed = 'failed',
    Loaded = 'loaded',
    InProgress = 'in-progress',
    WaitNextResult = 'wait_next_result',
}

export enum ServiceStatus {
    Active = 'active',
    Archived = 'archived',
}

export enum PriceStatus {
    Planned = 'Planned',
    Active = 'active',
    Archived = 'archived',
}

export enum PriceType {
    Base = 'base',
    Organization = 'organization',
    User = 'user',
    Contractor = 'contractor',
    Payer = 'payer',
}

export enum InformedConsentStatus {
    Signed = 'signed',
    Draft = 'draft',
}

// Ehr
export enum RepresentativeStatus {
    Confirmed = 'confirmed',
    NotConfirmed = 'not-confirmed',
}

export enum RepresentativeType {
    Child = 'child',
    Trustee = 'trustee',
    Other = 'other',
}

export enum EhrStatus {
    Active = 'active',
    Merged = 'merged',
}

// Ehr end
export enum SpecialtyStatus {
    Active = 'active',
    Archived = 'archived',
}

export enum AttachmentAction {
    Create = 'create',
    Truncate = 'truncate',
    Update = 'update',
    Unknown = 'unknown',
}

export enum AttachmentStatus {
    InProgress = 'in progress',
    Done = 'done',
    Failed = 'failed',
    Skipped = 'skipped',
}

export enum PlanType {
    Insurance = 'insurance',
    Organization = 'organization',
    Doctor = 'doctor',
    /**
     * LEGACY (DV-193): функционал докторских подписок выпилен из кода. Значение оставлено ради
     * существующих строк plan.type='doctor subscription' — без него загрузка таких планов падает
     * (createComputationPolicy / getComparator по PlanType). Ретайр требует прод data-миграции.
     */
    DoctorSubscription = 'doctor subscription',
    DoctorInsurance = 'doctor insurance',
    Patient = 'patient',
    GuarantyLetter = 'guaranty letter',
    WaitForGuarantyLetter = 'wait for guaranty letter',
    GuarantyLetterPlus = 'guaranty letter plus',
    Checkup = 'checkup',
}

export enum PayerType {
    Legal = 'legal',
    Individual = 'individual',
}

export enum PlanStatus {
    Active = 'active',
    Planned = 'planned',
    Archive = 'archive',
}

export enum ContractStatus {
    Active = 'active',
    Archive = 'archive',
}

export enum EhrTypeOfWork {
    Job = 'job',
    Study = 'Study',
    Other = 'other',
}

export enum Recipient {
    User = 'user',
    Patient = 'patient',
}

export enum TemplateName {
    ZoomMeetingLinks = 'ZoomMeetingLinks',
    RequiredPaymentCard = 'RequiredPaymentCard',
    CancellingWithPenalty = 'CancellingWithPenalty',
}

export enum UserSortingField {
    FirstName = 'firstName',
    LastName = 'lastName',
}

export enum UserSearchField {
    FullName = 'fullName',
    Email = 'email',
}

export enum RenderedServiceSortingField {
    EntryCreationTime = 'entryCreationTime',
}

export enum RequirementType {
    Device = 'device',
    Doctor = 'doctor',
    Office = 'office',
}

export enum ConditionStatus {
    Active = 'active',
    Archived = 'archived',
}

export enum DentalCondition {
    Normal = 'normal',
    Problem = 'problem',
    Warning = 'warning',
    Treated = 'treated',
    Missing = 'missing',
    Implant = 'implant',
    ImplantProblem = 'implantProblem',
}

export enum DentalTreatmentPlanStatus {
    Active = 'active',
    Archived = 'archive',
}

export enum DentalTreatmentStageStatus {
    Planned = 'planned',
    Performed = 'performed',
}

export enum OrganizationType {
    InsuranceCompany = 'insuranceCompany',
    Charity = 'charity',
    Assistance = 'assistance',
    Organization = 'organization',
    Clinic = 'clinic',
    ExternalClinic = 'externalClinic',
    Laboratory = 'laboratory',
    Contractor = 'contractor',
}

export enum OrganizationStatus {
    Active = 'active',
    Archived = 'archived',
}

export enum DeviceStatus {
    Active = 'active',
    Archived = 'archived',
}

export enum UserStatus {
    Active = 'active',
    Archived = 'archived',
}

export enum EntryTypeFieldName {
    NestedEntryType = 'nestedEntryType',
    PastMedicalHistoryEntryType = 'pastMedicalHistoryEntryType',
    MedicalIssuesEntryType = 'medicalIssuesEntryType',
    Legacy = 'legacy',
    Complains = 'complains',
    Pain = 'pain',
    MedicalHistory = 'medical history',
    Smoking = 'smoking',
    IsPregnant = 'isPregnant',
    MajorEvents = 'major events',
    MajorEventsNew = 'field voSJ5',
    SocialHistory = 'social history',
    SocialHistoryNew = 'field Ac5Ny',
    FamilyBackground = 'family background',
    FamilyBackgroundNew = 'field u6wcA',
    Conclusion = 'conclusion',
    AdditionalData = 'additionalData',
    Allergy = 'allergy',
    MedicalCases = 'medicalCases',
    DrugAllergy = 'drugAllergy',
    Drug = 'drug',
    NoseAndNasopharynx = 'nose and nasopharynx',
    OralCavity = 'oral cavity',
    RightEar = 'right ear',
    LeftEar = 'left ear',
    Larynx = 'larynx',
    LymphNodes = 'lymph nodes',
    AdditionalResearch = 'additional research',
    ObjectiveInspection = 'objective inspection',
    LastMenstrualPeriod = 'lastMenstrualPeriod',
    MenstrualFunction = 'menstrualFunction',
    LastPapTest = 'lastPapTest',
    AbnormalHistoryTest = 'abnormalHistoryTest',
    Pregnancy = 'pregnancy',
    GynecologistHistory = 'gynecologistHistory',
    SexualIntercourse = 'sexualIntercourse',
    Contraception = 'contraception',
    Height = 'height',
    Weigth = 'weight',
    BodyMassIndex = 'bodyMassIndex',
    BloodPressure = 'bloodPressure',
    Temperature = 'temperature',
    Pulse = 'pulse',
    RespiratoryRate = 'respiratoryRate',
    SO2 = 'SO2',
    GenitaliaExterna = 'genitaliaExterna',
    Vagina = 'vagina',
    Cervix = 'cervix',
    Uterus = 'uterus',
    Epoophoron = 'epoophoron',
    InguinalLymphNodes = 'inguinalLymphNodes',
    MammaryGland = 'mammaryGland',
    ApproachType = 'approachType',
    MenstrualIrregularities = 'menstrualIrregularities',
    DayOfMenstrualCycle = 'dayOfMenstrualCycle',
    UterusPosition = 'uterusPosition',
    UterusShape = 'uterusShape',
    UterusLongitudinalSize = 'uterusLongitudinalSize',
    UterusThickness = 'uterusThickness',
    UterusTransverseSize = 'uterusTransverseSize',
    MyometriumEchostructure = 'myometriumEchostructure',
    MesenchymalTumor = 'mesenchymalTumor',
    UterineCavity = 'uterineCavity',
    EndometrialEcho = 'endometrialEcho',
    MenstrualPhase = 'menstrualPhase',
    CervixLength = 'cervixLength',
    CervixThickness = 'cervixThickness',
    CervixWidth = 'cervixWidth',
    CervixStructure = 'cervixStructure',
    Endocervix = 'endocervix',
    RightOvaryPosition = 'rightOvaryPosition',
    RightOvaryLength = 'rightOvaryLength',
    RightOvaryThickness = 'rightOvaryThickness',
    RightOvaryWidth = 'rightOvaryWidth',
    RightOvaryVolume = 'rightOvaryVolume',
    RightOvaryEchostructure = 'rightOvaryEchostructure',
    RightOvaryFollicle = 'rightOvaryFollicle',
    RightOvaryTumor = 'rightOvaryTumor',
    RightOvaryOviduct = 'rightOvaryOviduct',
    LeftOvaryPosition = 'leftOvaryPosition',
    LeftOvaryLength = 'leftOvaryLength',
    LeftOvaryThickness = 'leftOvaryThickness',
    LeftOvaryWidth = 'leftOvaryWidth',
    LeftOvaryVolume = 'leftOvaryVolume',
    LeftOvaryEchostructure = 'leftOvaryEchostructure',
    LeftOvaryFollicle = 'leftOvaryFollicle',
    LeftOvaryTumor = 'leftOvaryTumor',
    LeftOvaryOviduct = 'leftOvaryOviduct',
    PouchOfDouglasDescription = 'pouchOfDouglasDescription',
    Referrals = 'referrals',
    LaboratoryTests = 'laboratoryTests',
    PatientFileName = 'patientFileName',
    PatientFileComment = 'patientFileComment',
    DentalTreatment = 'field owCAl',
    Vaccine = 'Vaccine',
    VaccinationType = 'field ENEW9',
    VaccinationStage = 'VaccinationStage',
    LaboratoryTestResults = 'laboratoryTestResults',
    Weight = 'weight',
    RenderedService = 'renderedService',
    MaterialAct = 'materialAct',
    InsuranceCoordination = 'field h9uJj',
    SickLeave = 'field iA4I9',
    ChronicDiseases = 'field DsDUR',
    InstrumentalResearchData = 'field E4ojN',
    LaboratoryResearchData = 'field RtqfO',
    MedicalHistoryNew = 'field 7IcK6',
    EntryEpisodes = 'entryEpisodes',
    EpisdodesDiagnosis = 'episdodesDiagnosis',
    EpisdodesReferrals = 'episdodesReferrals',
    EpisdodesDrugs = 'episdodesDrugs',
    EpisdodesRecommendations = 'episdodesRecommendations',
    EpisdodesTasks = 'episdodesTasks',
    EpisdodesPlanDescription = 'episdodesPlanDescription',
    ConclusionText = 'field w5ban',
    UsedMedicationsLegacyFirst = 'RegMeds',
    UsedMedicationsLegacySecond = 'field nw7ie',
    Teeth = 'field HkZkV',
}

export enum RenderedServiceStatus {
    Unpaid = 'unpaid',
    Paid = 'paid',
    PaymentPending = 'payment-pending',
    Credited = 'credited',
    Refunded = 'refunded',
    Canceled = 'canceled',
    Deleted = 'deleted',
}

export enum RenderedServiceType {
    Service = 'service',
    Subscription = 'subscription',
}

export enum AssistantType {
    Main = 'main',
    Temporary = 'temporary',
}

export enum ReferralServiceType {
    Simple = 'simple',
    Composite = 'composite',
}

export enum EhrIdentityDocType {
    RussianPassport = 'russian-passport',
    ForeignPassport = 'foreign-passport',
}

export enum MedicalCaseStatus {
    Open = 'open',
    Closed = 'closed',
    /**
     * @deprecated Больше нельзя отправлять эпизоды в холд
     */
    OnHold = 'onHold',
}

export enum MedicalCaseTaskState {
    Overdue = 'overdue',
    Active = 'active',
    WithoutActive = 'withoutActive',
    NoActiveOrOverdue = 'noActiveOrOverdue',
}

export enum ViewdType {
    Referral = 'referral',
}

export enum EntryTypeItemPresentationSubject {
    User = 'user',
    Entry = 'entry',
}

export enum EntryTypeItemType {
    Field = 'field',
    Block = 'block',
}

export enum ConditionsAgreement {
    Without = 'without',
    Required = 'required',
    Excluded = 'excluded',
}

export enum DictionaryItemStatus {
    Active = 'active',
    Archived = 'archived',
}

export enum RenderedServiceEventName {
    RenderedServiceCanceled = 'RenderedServiceCanceled',
    RenderedServiceCreated = 'RenderedServiceCreated',
    RenderedServiceDeleted = 'RenderedServiceDeleted',
    RenderedServiceMedicalCaseAdded = 'RenderedServiceMedicalCaseAdded',
    RenderedServiceMedicalCaseRemoved = 'RenderedServiceMedicalCaseRemoved',
    RenderedServicePaymentChanged = 'RenderedServicePaymentChanged',
    RenderedServicePlanAdded = 'RenderedServicePlanAdded',
    RenderedServicePlanChanged = 'RenderedServicePlanChanged',
    RenderedServicePlanRemoved = 'RenderedServicePlanRemoved',
    RenderedServiceContractorUpdated = 'RenderedServiceContractorUpdated',
    RenderedServiceStatusChanged = 'RenderedServiceStatusChanged',
    RenderedServiceUpdated = 'RenderedServiceUpdated',
}

export enum PaymentStatus {
    Pending = 'pending',
    Succeeded = 'succeeded',
    WaitingForCapture = 'waiting_for_capture',
    Error = 'error',
    Canceled = 'canceled',
    Refund = 'refund',
}

export enum PaymentType {
    Cash = 'cash',
    InternetAcquiring = 'internet-acquiring',
    MerchantAcquiring = 'merchant-acquiring',
    Yookassa = 'yookassa',
    PersonalAccount = 'personal-account',
    SetOffRefund = 'set-off-refund',
}

export enum OperationStatus {
    Preparing = 'preparing',
    Pending = 'pending',
    Done = 'done',
    Error = 'error',
    PreparingError = 'preparing-error',
    Fatal = 'fatal',
}

// Finance module start

export enum OperationType {
    Payment = 'payment',
    Refund = 'refund',
    AccountReplenishment = 'account_replenishment',
    RefundToAccount = 'refund_to_account',
    SubscriptionRefund = 'refund_subscription',
    WriteOff = 'write_off',
    Subscription = 'subscription',
}

export enum FinancePaymentStatus {
    Initialization = 'initialization',
    InitializationFailed = 'initialization_failed',
    Processing = 'processing',
    ProcessingFailed = 'processing_failed',
    WaitingForReceipt = 'waiting_for_receipt',
    ReceiptFailed = 'receipt_failed',
    Completed = 'completed',
    Canceled = 'canceled',
}

export enum ExternalPaymentStatus {
    Created = 'Created',
    Pending = 'Pending',
    Fulfilled = 'Fulfilled',
    Refunded = 'Refunded',
    Canceled = 'Canceled',
    Failed = 'Failed',
}

export enum ExternalRefundStatus {
    Pending = 'pending',
    Succeeded = 'succeeded',
    Failed = 'failed',
}

export enum PaymentMethodType {
    RaiffeisenQrPlate = 'raiffeisen_qr_plate',
    RaiffeisenSbpLink = 'raiffeisen_sbp_link',
    RaiffeisenTerminal = 'raiffeisen_terminal',
    YookassaCard = 'yookassa_card',
    IDramLight = 'idram_light',
    TelcellLight = 'telcell_light',
    ArcaLink = 'arca_link',
    Transfer = 'transfer',
    Manual = 'manual',
    ManualWithoutReceipt = 'manual_without_receipt',
    MockTerminal = 'mock_terminal',
    MockCash = 'mock_cash',
    TBankLinkSplit = 'tbank_link_split',
    // Legacy types
    Cash = 'cash',
    InternetAcquiring = 'internet-acquiring',
    MerchantAcquiring = 'merchant-acquiring',
    Yookassa = 'yookassa',
    PersonalAccount = 'personal-account',
    SetOffRefund = 'set-off-refund',
    PaymentUrlTypeYooKassa = 'payment-url-yookassa',
    PaymentUrlTypeSBP = 'payment-url-sbp',
    // Legacy types end
}

export enum RefundMethod {
    Accounting = 'accounting',
    Manual = 'manual',
}

export enum ReceiptProviderType {
    OrangeData = 'orange-data',
    Atol = 'atol',
    PayX = 'payx',
}

export enum FfdVersion {
    FFD_105 = '1.05',
    FFD_12 = '1.2',
}

export enum ReceiptStatus {
    Pending = 'pending',
    Done = 'done',
    Error = 'error',
    Cancelled = 'cancelled',
}

export enum ExternalReceiptStatus {
    Completed = 'completed',
    InProgress = 'in-progress',
    Failed = 'failed',
}

export enum PaymentEquipmentType {
    Plate = 'plate',
    Terminal = 'terminal',
}

export enum PaymentWorkplaceStatus {
    Active = 'active',
    Archived = 'archived',
}

// Finance module end

export enum ServiceGroupStatus {
    Active = 'active',
    Archive = 'archive',
}

export enum ServiceGroupItemStatus {
    Active = 'active',
    Archive = 'archive',
    Planned = 'planned',
}

export enum CardStatus {
    Active = 'active',
    Archived = 'archived',
}

export enum PrePaymentMethod {
    ALL = 'all',
    SBP = 'sbp',
    RAIF_SBP = 'raif_sbp',
    ARCA_LINK = 'arca_link',
}

export enum LaboratoryStatus {
    Active = 'active',
    Archive = 'archive',
}

export enum EntryStatus {
    Signed = 'signed',
    Unsigned = 'unsigned',
    ReadyForDescribing = 'readyForDescribing',
    Draft = 'draft',
    Archive = 'archive',
    OnReview = 'onReview',
    ReviewCompleted = 'reviewCompleted',
}

export enum EntryStatusCustom {
    WithEds = 'withEds',
    WithoutEds = 'withoutEds',
}

export enum EntryTranslationStatus {
    InProgress = 'inProgress',
    Confirmed = 'confirmed',
}

export enum EntryAudioRecordStatus {
    /** Идёт диалоговая запись: сессия создана на init, принимаются chunk'и, finalize ещё не было. */
    Recording = 'recording',
    /** Запись создана, но ещё не отправлена на транскрипцию. */
    New = 'new',
    /** Отправлена/переотправлена на транскрипцию, поллер ждёт результат. */
    TranscriptionInProgress = 'in-progress',
    /** Клиентский промежуточный статус «загружено» (сейчас практически не используется). */
    Uploaded = 'uploaded',
    /** Результат получен: текст/диалог готов. */
    Transcribed = 'transcribed',
    /** Врач принял результат — терминальное состояние. */
    Finished = 'finished',
    /** Ошибка или таймаут транскрипции. */
    Error = 'error',
    /** Диалоговая сессия отменена врачом (удаление/закрытие вкладки) — терминальное состояние, reaper её не трогает. */
    Cancelled = 'cancelled',
}

/**
 * Шаг обработки внутри статусов New и TranscriptionInProgress: расшифровка диалога и его
 * структурирование — это два последовательных запроса к сервису транскрипции, и оба держат
 * запись в одном статусе.
 */
export enum EntryAudioRecordProcessingStage {
    /** Запись создана, аудио сервисом транскрипции ещё не принято. */
    Submitting = 'submitting',
    /** Первый запрос: аудио ушло на расшифровку. */
    Transcribing = 'transcribing',
    /** Второй запрос: расшифрованный диалог ушёл на структурирование. */
    Structuring = 'structuring',
}

export enum CreateOrdersStatus {
    /** Обработка ещё не запускалась — фронт не показывает статус. */
    Hidden = 'hidden',
    /** Идёт генерация плана и создание назначений. */
    Processing = 'processing',
    /** Все назначения созданы. */
    Success = 'success',
    /** Часть назначений создать не удалось. */
    Partial = 'partial',
    /** Не удалось создать назначения (или не удалось расшифровать). */
    Error = 'error',
}

export enum PlanOrderField {
    Referral = 'referral',
    Recommendation = 'recommendation',
    Drug = 'drug',
    Task = 'task',
}

export enum EntryReviewStatus {
    New = 'new',
    InProgress = 'in-progress',
    Completed = 'completed',
    Error = 'error',
}

export enum EntryReviewLifecycleStatus {
    ReviewNeeded = 'reviewNeeded',
    RepeatReviewNeeded = 'repeatReviewNeeded',
    InProgress = 'inProgress',
    Completed = 'completed',
}

export enum EntryReviewTargetType {
    Entry = 'entry',
    Episode = 'episode',
}

export enum LegalEntityType {
    InsuranceCompany = 'insuranceCompany',
    Charity = 'charity',
    Assistance = 'assistance',
    Organization = 'organization',
    Clinic = 'clinic',
    ExternalClinic = 'externalClinic',
    Laboratory = 'laboratory',
    Contractor = 'contractor',
}

export enum LegalEntityStatus {
    Active = 'active',
    Archived = 'archived',
}

export enum LegalEntityQueryField {
    Name = 'name',
    Abbreviation = 'abbreviation',
}

export enum OrganizationQueryField {
    Name = 'name',
    Abbreviation = 'abbreviation',
}

export enum ClinicalNoteStatus {
    Signed = 'signed',
    Draft = 'draft',
}

export enum EpisodeShortStatus {
    PLANNED = 'PLANNED',
    WAITLIST = 'WAITLIST',
    ACTIVE = 'ACTIVE',
    ONHOLD = 'ONHOLD',
    FINISHED = 'FINISHED',
    CANCELLED = 'CANCELLED',
    ENTERED_IN_ERROR = 'ENTERED_IN_ERROR',
}

export enum IndividualReportType {
    Entry = 'entry',
    PaymentAct = 'paymentAct',
    PatientReservations = 'patientReservations',
}

export namespace PaymentService {
    export enum PaymentProvider {
        Yookassa = 'Yookassa',
        Raiffeisen = 'Raiffeisen',
        Arca = 'Arca',
        TBank = 'TBank',
    }

    export enum PaymentMethod {
        Card = 'Card',
        FPS = 'FPS',
        Link = 'Link',
        QR = 'QR',
        Terminal = 'Terminal',
    }

    export enum PaymentStatus {
        Created = 'Created',
        Pending = 'Pending',
        Fulfilled = 'Fulfilled',
        Refunded = 'Refunded',
        Canceled = 'Canceled',
        Failed = 'Failed',
    }

    export enum Currency {
        RUB = 'RUB',
        USD = 'USD',
        EUR = 'EUR',
        GEL = 'GEL',
    }

    export enum SlipType {
        Sell = 'sell',
        Buy = 'buy',
        SellReturn = 'sellReturn',
        BuyReturn = 'buyReturn',
    }

    export enum PaymentType {
        Cash = 'cash', // - наличными
        Cashless = 'electronically', // - безналичными
        Prepaid = 'prepaid', // - предварительная оплата (аванс)
        Credit = 'credit', // - последующая оплата (кредит)
        Other = 'other', // - иная форма оплаты (встречное предоставление)
    }

    export enum PaymentMethodType {
        FullPrepayment = 'fullPrepayment',
        Prepayment = 'prepayment',
        Advance = 'advance',
        FullPayment = 'fullPayment',
        PartialPayment = 'partialPayment',
        Credit = 'credit',
        CreditPayment = 'creditPayment',
    }

    export enum ReceiptProvider {
        OrangeData = 'orange-data',
        Atol = 'atol',
        PayX = 'payx',
    }
}

export enum TaxType {
    None = 'none',
    Vat0 = 'vat0',
    Vat10 = 'vat10',
    Vat110 = 'vat110',
    Vat20 = 'vat20',
    Vat22 = 'vat22',
    Vat120 = 'vat120',
}

export enum PositionType {
    Commodity = 'commodity',
    Excise = 'excise',
    Job = 'job',
    Service = 'service',
    GamblingBet = 'gamblingBet',
    GamblingPrize = 'gamblingPrize',
    Lottery = 'lottery',
    LotteryPrize = 'lotteryPrize',
    IntellectualActivity = 'intellectualActivity',
    Payment = 'payment',
    AgentCommission = 'agentCommission',
    Pay = 'pay',
    Another = 'another',
    ProprietaryLaw = 'proprietaryLaw',
    NonOperatingIncome = 'nonOperatingIncome',
    InsuranceContributions = 'insuranceContributions',
    MerchantTax = 'merchantTax',
    ResortFee = 'resortFee',
    Deposit = 'deposit',
}

export enum AgentType {
    BankPayingAgent = 'bankPayingAgent',
    BankPayingSubagent = 'bankPayingSubagent',
    PayingAgent = 'payingAgent',
    PayingSubagent = 'payingSubagent',
    Attorney = 'attorney',
    CommissionAgent = 'commissionAgent',
    Another = 'another',
}

export enum DiagnosisType {
    Acute = 'acute',
    Chronic = 'chronic',
    Preventative = 'preventative',
}

export enum FieldStatus {
    Active = 'active',
    Deleted = 'deleted',
}

export enum DrugStatus {
    Active = 'active',
    Cancelled = 'cancelled',
    CancelledAppointment = 'cancelledAppointment',
    CanceledByPatient = 'cancelledByPatient',
}

export enum MedicationStatus {
    Active = 'active',
    Deleted = 'deleted',
    CancelledAppointment = 'cancelledAppointment',
    CanceledByPatient = 'cancelledByPatient',
}

export enum EntryOrder {
    CreationTime = 'creationTime',
    VisitTime = 'visitTime',
    Urgency = 'isUrgent',
}

export enum TaskRepetitionPeriod {
    Daily = 'daily',
    Weekly = 'weekly',
    Monthly = 'monthly',
    Yearly = 'yearly',
}

export enum TaskStatus {
    Requested = 'requested',
    Completed = 'completed',
    Cancelled = 'cancelled',
}

export enum FhirTaskStatus {
    Requested = 'requested',
    Cancelled = 'cancelled',
    Accepted = 'accepted',
    Rejected = 'rejected',
    Failed = 'failed',
    Completed = 'completed',
    Draft = 'draft',
    Received = 'received',
    Ready = 'ready',
    InProgress = 'in-progress',
    OnHold = 'on-hold',
    EnteredInError = 'entered-in-error',
    // Deviation from FHIR
    Started = 'started',
    Expired = 'expired',
}

export enum TaskUrgency {
    Routine = 'routine',
    Urgent = 'urgent',
    Asap = 'asap',
    Stat = 'stat',
}

export enum EntryTypeStatus {
    Active = 'active',
    Draft = 'draft',
    Archived = 'archived',
}

export enum EntryTypeBlockStatus {
    Active = 'active',
    Draft = 'draft',
    Archived = 'archived',
}

export enum EntryTypeFieldType {
    Text = 'text',
    String = 'string',
    Number = 'number',
    Link = 'link',
    Select = 'select',
    MultiSelect = 'multiSelect',
    TextList = 'textList',
    OptionalText = 'optionalText',
    Date = 'date',
    Toggle = 'toggle',
    Computed = 'computed',
    CustomComputed = 'customComputed',
    CheckboxList = 'checkboxList',
    CheckboxWithText = 'checkboxWithText',
    SelectionButtons = 'selectionButtons',
    Scale = 'scale',
    DrugAllergy = 'drugAllergy',
    Allergy = 'allergy',
    MedicalCases = 'medicalCases',
    Drug = 'drug',
    Pregnancy = 'pregnancy',
    Referrals = 'referrals',
    RenderedService = 'renderedService',
    MaterialAct = 'materialAct',
    Table = 'table',
    CheckboxWithTextList = 'checkboxWithTextList',
    LegacyData = 'legacyData',
    NestedEntryType = 'nestedEntryType',
    LaboratoryTests = 'laboratoryTests',
    DentalTreatment = 'dentalTreatment',
    EntryMedicalCases = 'entryMedicalCases',
    Vaccinations = 'vaccinations',
    UsedMedications = 'usedMedications',
    EntryEpisodes = 'entryEpisodes',
    EpisdodesDiagnosis = 'episdodesDiagnosis',
    EpisdodesReferrals = 'episdodesReferrals',
    EpisdodesDrugs = 'episdodesDrugs',
    EpisdodesRecommendations = 'episdodesRecommendations',
    EpisdodesTasks = 'episdodesTasks',
    EpisdodesPlanDescription = 'episdodesPlanDescription',
}

export enum DateMode {
    FutureOnly = 'FutureOnly',
    PastOnly = 'PastOnly',
    AnyDate = 'AnyDate',
}

export enum TableFieldCellType {
    Title = 'title',
    Input = 'input',
    String = 'string',
    MinValue = 'minValue',
    MaxValue = 'maxValue',
    Formula = 'formula',
    Checkbox = 'checkbox',
    Calculate = 'Calculate',
    Select = 'select',
}

export enum FileEntityType {
    Entry = 'entry',
    Ehr = 'ehr',
    LegalEntityIndividualReport = 'legalEntityIndividualReport',
    Organization = 'organization',
}

export enum FileStatus {
    Uploading = 'uploading',
    Uploaded = 'uploaded',
}

export enum PatientDocumentStatus {
    Active = 'active',
    Archived = 'archived',
}

export enum EntryFileCategory {
    Laboratory = 'laboratory',
    Diagnostic = 'diagnostic',
    PrintForm = 'printForm',
}

export enum NetworkStatus {
    Active = 'active',
    Archived = 'archived',
}

export enum OfficeStatus {
    Active = 'active',
    Archived = 'archived',
}

export enum DeviceTypeStatus {
    Active = 'active',
    Archived = 'archived',
}

export enum WorkListStatus {
    Sent = 'sent',
    Failed = 'failed',
}

export enum Modality {
    ComputedRadiography = 'CR',
    ComputedTomography = 'CT',
    MagneticResonance = 'MR',
    Ultrasound = 'US',
    RadiographicImaging = 'RG',
    Other = 'OT',
}

export enum OfficeTypeStatus {
    Active = 'active',
    Archived = 'archived',
}

export enum ScheduleOrderingField {
    OFFICE = 'office',
    SPECIALTY = 'specialty',
    USER = 'user',
    DAY = 'day',
}

export enum WorkTimeStatus {
    Active = 'active',
    Proposal = 'proposal',
    Draft = 'draft',
}

export enum ScheduleRuleShift {
    Morning = 'morning',
    Evening = 'evening',
}

export enum ScheduleRuleRole {
    Doctor = 'doctor',
    Assistant = 'assistant',
    AdditionalDoctor = 'additional_doctor',
}

export enum ScheduleRuleRecurrence {
    Week = 'week',
    Month = 'month',
}

export enum Languages {
    English = 'English',
    Arab = 'Arab',
    Chinese = 'Chinese',
    German = 'German',
    French = 'French',
    Spanish = 'Spanish',
    Portuguese = 'Portuguese',
    Turkish = 'Turkish',
    Russian = 'Russian',
    Georgian = 'Georgian',
    Azerbaijani = 'Azerbaijani',
    Armenian = 'Armenian',
    Belorussian = 'Belorussian',
    Kazakh = 'Kazakh',
    Kyrgyz = 'Kyrgyz',
    Moldavian = 'Moldavian',
    Tajik = 'Tajik',
    Turkmen = 'Turkmen',
    Uzbek = 'Uzbek',
    Ukrainian = 'Ukrainian',
    Hebrew = 'Hebrew',
    Dutch = 'Dutch',
}

export enum Country {
    Russia = 'Russia',
    Georgia = 'Georgia',
    Armenia = 'Armenia',
    UAE = 'UAE',
    Portugal = 'Portugal',
    UnitedKingdom = 'UnitedKingdom',
}

export enum MessageChannel {
    Tg = 'tg',
    Vb = 'vb',
    Sms = 'sms',
    Email = 'email',
    Wa = 'wa',
}

export enum ServiceTax {
    '20%' = '20%',
    '22%' = '22%',
    '18%' = '18%',
    '10%' = '10%',
    '20/120%' = '20/120%',
    '10/110%' = '10/110%',
    '0%' = '0%',
    'without' = 'without',
}

export enum TechnicalStatus {
    Active = 'active',
    Deleted = 'deleted',
    Archive = 'archive',
}

export enum Restrictions {
    Doctor = 'doctor',
    Referral = 'referral',
}

export enum DictionaryNames {
    FoodAllergen = 'foodAllergen',
    EnvironmentAllergen = 'environmentAllergen',
    AllergyReaction = 'allergyReaction',
    Mkb10 = 'mkb10',
    Drug = 'drug',
    ElementDrug = 'elementDrug',
    DrugTradeNames = 'drugTradeNames',
    InjectionSite = 'injectionSite',
    DeliveryMethod = 'deliveryMethod',
    Pregnancy = 'pregnancy',
    Expertiza = 'Expertiza',
    TeethFormulaAdult = 'teethFormulaAdult',
    EpisodeName = 'episodeName',
    VaccinationReaction = 'vaccinationReaction',
}

export enum Locale {
    Ru = 'ru',
    En = 'en',
    Ge = 'ge',
    Am = 'am',
    Pt = 'pt',
}

export enum YandexLocale {
    Ru = 'ru',
    En = 'en',
    Ge = 'ka',
    Am = 'hy',
    Pt = 'pt',
}

export enum CountryCode {
    Ru = 'RU',
    Am = 'AM',
    Ge = 'GE',
    Ae = 'AE',
    Pt = 'PT',
    Gb = 'GB',
}

export enum FeatureName {
    UseEntryReview = 'useEntryReview',
    AsyncReceipts = 'asyncReceipts',
    UseServiceCoverageStatus = 'useServiceCoverageStatus',
    ServiceCoverageStatusTab = 'serviceCoverageStatusTab',
    RealtimeDictation = 'realtimeDictation',
    CdaGeneration = 'cdaGeneration',
    PushFirstNotifications = 'pushFirstNotifications',
    SplitPayment = 'splitPayment',
}

export enum CdaDeliveryStatus {
    Queued = 'queued',
    Sent = 'sent',
    Registered = 'registered',
    Failed = 'failed',
}

export enum LlmPromptName {
    EntryReview = 'entry_review',
    EpisodeReview = 'episode_review',
}

// Realtime transcription protocol values; message types live in chaika-frontend-types
export const REALTIME_TRANSCRIPTION_PATH = '/api/transcription/realtime';

export enum RealtimeTranscriptionErrorCode {
    ProviderConnectFailed = 'provider-connect-failed',
    ProviderStalled = 'provider-stalled',
    ProviderError = 'provider-error',
    Internal = 'internal',
    ServerShutdown = 'server-shutdown',
    SessionExpired = 'session-expired',
    IdleTimeout = 'idle-timeout',
    Capacity = 'capacity',
    ProtocolViolation = 'protocol-violation',
}

export enum RealtimeTranscriptionCloseCode {
    ProviderConnectFailed = 4001,
    ProviderStalled = 4002,
    ProviderError = 4003,
    Capacity = 4004,
    ProtocolViolation = 4005,
    SessionExpired = 4006,
    Internal = 4008,
    IdleTimeout = 4009,
}

export enum Currency {
    RUB = 'RUB',
    AED = 'AED',
    USD = 'USD',
    EUR = 'EUR',
    GEL = 'GEL',
    AMD = 'AMD',
    GBP = 'GBP',
}

export enum FormulaType {
    Permanent = 'permanent',
    Baby = 'baby',
}

/** @deprecated formula types for native Dental Page*/
export enum DentalFormulaType {
    Permanent = 'permanent',
    Baby = 'baby',
    Mixed = 'mixed',
    MixedPermanent = 'mixedPermanent',
    MixedBaby = 'mixedBaby',
}

export enum Severity {
    Severe = '24484000',
    Moderate = '6736007',
    Mild = '255604002',
}

export enum ClinicalStatus {
    Active = 'ACTIVE',
    Recurrence = 'RECURRENCE',
    Relapse = 'RELAPSE',
    Inactive = 'INACTIVE',
    Remission = 'REMISSION',
    Resolved = 'RESOLVED',
}

export enum VerificationStatus {
    Unconfirmed = 'UNCONFIRMED',
    Provisional = 'PROVISIONAL',
    Differential = 'DIFFERENTIAL',
    Confirmed = 'CONFIRMED',
    Refuted = 'REFUTED',
    EnteredInError = 'ENTERED_IN_ERROR',
}

export enum SpatialZoneName {
    Buccal = 'buccal',
    Distal = 'distal',
    Lingual = 'lingual',
    Mesial = 'mesial',
    Occlusal = 'occlusal',
    FourZone = 'fourZone',
    FiveZone = 'fiveZone',
    Root = 'root',
    AllLowerJaw = 'allLowerJaw',
    AllUpperJaw = 'allUpperJaw',
}

export enum InformedConsentTemplateType {
    Patient = 'patient',
    Service = 'service',
}

export enum LaboratoryIntegrationType {
    NadiaLab = 'nadia-lab',
    AstraLab = 'astra-lab',
}

export enum LaboratoryServiceServiceStatus {
    Active = 'active',
    Archived = 'archived',
}

// System module

export enum ProfilerLogStatus {
    Pending = 'pending',
    Success = 'success',
    Failed = 'failed',
}

export enum UsageStatisticEntityType {
    Speciality = 'speciality',
}

// System module end

// Replication

export enum ReplicationEntity {
    Entry = 'entry',
    EntrySnapshot = 'entry_snapshot',
    EventStore = 'event_store',
    FinancePayment = 'finance.payment',
    WorkTime = 'work_time',
    ScheduleWorkTime = 'schedule_work_time',
    ScheduleModel = 'schedule_model',
    MedicalCase = 'medical_case',
    Contract = 'contract',
    Ehr = 'ehr',
    LegalEntity = 'legal_entity',
    Referral = 'referral',
    ReferralEventStore = 'referral_event_store',
    RenderedServiceView = 'rendered_service_view',
    Reservation = 'reservation',
    ReservationEventStore = 'reservation_event_store',
    Subscription = 'subscription',
    Organization = 'organization',
    Plan = 'plan',
    Service = 'service',
    PersonalAccount = 'finance.personal_account',
    ReferralCompositeService = 'referral_composite_service',
    ReferralCompositeServicePlan = 'referral_composite_service_plan',
    ReferralLaboratoryService = 'referral_laboratory_service',
    Price = 'price',
}

export enum ReplicationEntityWithoutTimeColumn {
    Office = 'office',
    Users = 'users',
    // Dictionary = 'dictionary',
    Device = 'device',
    PaymentMethod = 'finance.payment_method',
}

// Insurance module

export enum ProtestActStatus {
    New = 'new',
    InProcess = 'inProcess',
    Finish = 'finish',
    Deleted = 'deleted',
}

export enum ProtestActItemStatus {
    New = 'new',
    InProcess = 'inProcess',
    Processed = 'processed',
    Finish = 'finish',
}
export enum ProtestActItemCalculateDataStatus {
    Ok = 'ok',
    Error = 'error',
}

// Insurance module end

export enum ReplicationUpdateType {
    InsertUpdate = 'insertUpdate',
    WithoutTimeColumn = 'withoutTimeColumn',
    SimpleIdUpdate = 'simpleIdUpdate',
    Update = 'update',
}

// Schedule

export enum ReservationStatus {
    Reserved = 'reserved',
    Cancelled = 'cancelled',
    VisitOccurred = 'visitOccurred',
}

export enum ReservationType {
    Visit = 'visit',
    OnlineVisit = 'online visit',
    Draft = 'draft',
    Lunch = 'lunch',
    Vacation = 'vacation',
    Disease = 'disease',
    Meeting = 'meeting',
    Training = 'training',
    NotWorkTime = 'not work time',
    Vaccination = 'vaccination',
    Collection = 'collection',
    WaitingList = 'waiting list',
    Operation = 'operation',
    Appointment = 'appointment',
    OnlineAppointment = 'online_appointment',
    TimeBlock = 'time_block',
    RoomBooking = 'room_booking',
}

export enum ReservationCancellingType {
    Manually = 'manually',
    AutomaticByPaymentCardAbsence = 'automatic by payment card absence',
    Fined = 'fined',
}

export enum ReservationSortingField {
    StartTime = 'startTime',
}

export enum ReservationEventType {
    OnlineVisitUpdated = 'OnlineVisitUpdated',
    VisitCancelled = 'VisitCancelled',
    OfficeVisitUpdated = 'OfficeVisitUpdated',
    OfficeVisitCreated = 'OfficeVisitCreated',
    VisitReservationUpdated = 'VisitReservationUpdated',
    ReservationStatusUpdated = 'ReservationStatusUpdated',
    VisitReservationCreated = 'VisitReservationCreated',
    OnlineVisitCreated = 'OnlineVisitCreated',
    VisitReservationStatusUpdated = 'VisitReservationStatusUpdated',
    VisitOccurred = 'VisitOccurred',
}

export enum ScheduleStatisticEntityType {
    Speciality = 'speciality',
    Service = 'service',
    Doctor = 'doctor',
}

export enum PriceReportType {
    Base = 'base',
    Individual = 'individual',
}

// Schedule end

export enum SubscriptionOrderStatus {
    Created = 'created',
    Paid = 'paid',
    Active = 'active',
    Canceled = 'canceled',
    Expired = 'expired',
}

export enum AnnualProgramStatus {
    Created = 'created',
    Paid = 'paid',
    Active = 'active',
    Canceled = 'canceled',
    Expired = 'expired',
}

export enum AuditEventEntityType {
    Service = 'Service',
    Price = 'Price',
    WorkTime = 'WorkTime',
    Assistant = 'Assistant',
    ScheduleModel = 'ScheduleModel',
    Ehr = 'Ehr',
    Entry = 'Entry',
    Unknown = 'Unknown',
    Plan = 'Plan',
    Users = 'Users',
}

export enum AuditEventType {
    ServiceStatusUpdate = 'ServiceStatusUpdate',
    ServiceUpdate = 'ServiceUpdate',
    ServiceCreate = 'ServiceCreate',
    PriceCreated = 'PriceCreated',
    PriceArchived = 'PriceArchived',
    PriceUpdate = 'PriceUpdate',
    PriceStatusUpdate = 'PriceStatusUpdate',
    WorkTimeBulkUpdate = 'WorkTimeBulkUpdate',
    WorkTimeCreate = 'WorkTimeCreate',
    WorkTimeUpdate = 'WorkTimeUpdate',
    WorkTimeRemove = 'WorkTimeRemove',
    AssistantCreate = 'AssistantCreate',
    AssistantUpdate = 'AssistantUpdate',
    AssistantRemove = 'AssistantRemove',
    EhrFind = 'EhrFind',
    EhrCreated = 'EhrCreated',
    EhrUpdated = 'EhrUpdated',
    EhrViewed = 'EhrViewed',
    EntryViewed = 'EntryViewed',
    ScheduleModelCreated = 'ScheduleModelCreated',
    ScheduleModelUpdated = 'ScheduleModelUpdated',
    ScheduleModelStatusUpdated = 'ScheduleModelStatusUpdated',
    PlanUpdated = 'PlanUpdated',
    PlanCreated = 'PlanCreated',
    UsetCreated = 'UsetCreated',
    UsetUpdated = 'UsetUpdated',
    UsetStatusUpdate = 'UsetStatusUpdate',
    UsetRoleUpdate = 'UsetRoleUpdate',
    FeatureUpdated = 'FeatureUpdated',
    UpdateTranslation = 'UpdateTranslation',
    LlmPromptUpdated = 'LlmPromptUpdated',
    LlmPromptCreated = 'LlmPromptCreated',
    EhrAccessChecked = 'EhrAccessChecked',
    CrossCountryView = 'CrossCountryView',
}

export enum EhrViewContext {
    PatientPage = 'patient-page',
    EntryPage = 'entry-page',
}

export enum SubscriptionOrderChatLinkStatus {
    Updating = 'updating',
    Failed = 'failed',
    Done = 'done',
}

export enum SessionStorageKeys {
    LastViewedEntries = 'lastViewedEntries',
    FromAuthPage = 'fromAuthPage',
}

export enum DiscountType {
    Flat = 'flat',
    Average = 'average',
    Hurdle = 'hurdle',
}

export enum TaxDeductionEntityType {
    Service = 'service',
    Subscription = 'subscription',
}

export enum OneCMaterialActStatus {
    Pending = 'pending',
    Sending = 'sending',
    Succeeded = 'succeeded',
    Error = 'error',
    Canceled = 'canceled',
}

export enum RecurringSubscriptionStatus {
    Active = 'active',
    WaitingForPayment = 'waitingForPayment',
    Cancelled = 'cancelled',
}

export enum RecurringSubscriptionComputedStatus {
    Active = 'active',
    Trial = 'trial',
    Cancelled = 'cancelled',
}

export enum RecurringSubscriptionExtendedStatus {
    NotStarted = 'notStarted',
    Active = 'active',
    Refunded = 'refunded',
    Ended = 'ended',
}

export enum RecurringSubscriptionRenewPeriod {
    Monthly = 'monthly',
    Annual = 'annual',
}

export enum Tabs {
    Subjective = 'subjective',
    Objective = 'objective',
    Assessment = 'assessmentLikeEpisodes',
    Plan = 'plan',
    Billing = 'billing',
    Review = 'review',
}

export enum EntryCheckStatus {
    Default = 'default',
    InProgress = 'inProgress',
    Warn = 'warn',
    Critical = 'critical',
    Good = 'good',
    Excellent = 'excellent',
}

export enum SubscriptionPriceStatus {
    Active = 'active',
    Archived = 'archived',
}

export enum SubscriptionStatus {
    Active = 'active',
    Archived = 'archived',
    Planned = 'planned',
}

export enum ZoomRecordingLocation {
    Local = 'local',
    Cloud = 'cloud',
    None = 'none',
}

export enum SavedPaymentMethodType {
    Card = 'card',
    SBP = 'sbp',
}

export enum SavedPaymentMethodStatus {
    Active = 'active',
    Archived = 'archived',
    Pending = 'pending',
}

export enum SharedSavedPaymentMethodStatus {
    Active = 'active',
    Suspended = 'suspended',
    Archived = 'archived',
}

export enum FinancePaymentProvider {
    Yookassa = 'Yookassa',
    Raiffeisen = 'Raiffeisen',
    Arca = 'Arca',
    TBank = 'TBank',
}

export enum RoleName {
    HeadOfClinic = 'head_of_clinic',
    PracticeLeader = 'practice_leader',
    Doctor = 'doctor',
    Assistant = 'assistant',
    Helpdesk = 'helpdesk',
    Developer = 'developer',
    Accountant = 'accountant',
    MedicalDirector = 'medical_director',
    Care = 'care',
    ProcedureNurse = 'procedure_nurse',
}

export enum MostPopularEntityType {
    MedicalCaseName = 'medicalCaseName',
}

export enum UserPreferenceType {
    ReferralLaboratory = 'referralLaboratory',
}

export enum GrantKind {
    Create = 'create',
    Extend = 'extend',
    Revoke = 'revoke',
}

export enum GrantSource {
    Reservation = 'reservation',
    Referral = 'referral',
    Episode = 'episode',
    Entry = 'entry',
    Task = 'task',
    Recommendation = 'recommendation',
    RecurringSubscription = 'recurring_subscription',
    Self = 'self',
}

export enum RevokeReason {
    SourceArchived = 'source_archived',
    SourceDeleted = 'source_deleted',
    SourceClosed = 'source_closed',
    SourceCompleted = 'source_completed',
    TtlExpired = 'ttl_expired',
    Blacklisted = 'blacklisted',
    Manual = 'manual',
}

export enum EhrAccessMemberStatus {
    Active = 'active',
    Expired = 'expired',
    Blocked = 'blocked',
}

export enum EhrAccessGrantSortingField {
    GrantedAt = 'grantedAt',
}

export enum EhrAccessBlacklistSortingField {
    BlockedAt = 'blockedAt',
}

export enum EntrySoapGroup {
    Subjective = 'subjective',
    Objective = 'objective',
    Assessment = 'assessment',
    Plan = 'plan',
    Payment = 'payment',
}

// Значения совпадают с HTTP-полем `code` доменных ошибок расписания
// (имя класса минус суффикс Error); фронт матчит по ним `error.name`.
export enum ScheduleRuleErrorCode {
    OfficeOccupied = 'ScheduleRuleOfficeOccupied',
    UserOccupied = 'ScheduleRuleUserOccupied',
    HasActiveReservations = 'ScheduleRuleHasActiveReservations',
    AssistantPracticeMismatch = 'ScheduleRuleAssistantPracticeMismatch',
    MultipleOffices = 'ScheduleRuleMultipleOffices',
    BatchConflict = 'ScheduleRuleBatchConflict',
}

export enum ReservationErrorCode {
    HasIntersection = 'ReservationHasIntersection',
    AgeForbidden = 'AgeForbidden',
}

export enum TimeBlockRuleErrorCode {
    Conflict = 'TimeBlockRuleConflict',
}

export enum DeviceReservationType {
    Booking = 'booking',
    OccupiedTime = 'occupied_time',
}

export enum DeviceReservationStatus {
    Reserved = 'reserved',
    Cancelled = 'cancelled',
}

export enum DeviceOccupancyErrorCode {
    Conflict = 'DeviceOccupancyConflict',
}

export enum EntryArchiveExportStatus {
    InProgress = 'inProgress',
    Completed = 'completed',
    Failed = 'failed',
}

export enum DrugSearchEntryKind {
    Substance = 'substance',
    Trade = 'trade',
}

export enum NsiDictionaryName {
    DoctorPosition = 'doctorPosition',
    FrmrPosition = 'frmrPosition',
    RemdRole = 'remdRole',
    Region = 'region',
}
